<div class="roi-page tp-roi new-input-fields tp-retrun-investment-tab" style="margin-bottom: 10rem;" [ngClass]="[
filterOptions.actual ? 'increase-space' : 'reduce-space',
isCustomer ? 'isCustomer' : '']">
  <div class="row" style="margin-top: 20px;">
    <div class="medium-4 column medium-centered text-center" *ngIf="displayLogo">
      <div class="tp-firm-logo mb-2" [ngStyle]="logoBg"></div>
    </div>
  </div>
  <div class="row">
    <div class="medium-2 column"></div>
    <div class="medium-8 column text-center heading">
      Tax Savings Analysis for {{taxYear || ''}}
    </div>
    <div class="medium-2 column"></div>
  </div>
  <div class="row mt-2 mb-3">
    <div class="medium-2 column section-icon">
      <span *ngIf="!isCustomer && minimizedSections.length>0" (click)="showAllHiddenSections()">
        <i class="icon ion-android-add"></i>
      </span>
    </div>
    <div class="medium-8 column name-box">
      <div class="row">
        <div class="medium-6" style="display: flex">
          <div style="font-weight: 500;">Client: </div>
          <div class="name-ellips" style="margin-left: 5px;"> {{roiData.userName}}</div>
        </div>
        <div class="medium-6" style="display: flex">
          <div style="margin-left: 2rem;font-weight: 500;">Plan: </div>
          <div class="name-ellips" style="margin-left: 5px;"> {{roiData.strategyName}}</div>
        </div>
      </div>
    </div>
    <div class="medium-2 column"></div>
  </div>
  <div class="row mb-3" *ngIf="filterOptions.actual">
    <div class="medium-12 column">
      <div class="row">
        <div class="medium-6 column"></div>
        <div class="medium-6 column">
          <div class="row">
            <div class="medium-3 column table-header-badge-tooltip">
              <span class="roi-table-heading">Planned Amount</span>
              <span class="bottomTooltiptext status-tooltip">Tax Savings amount in the proposal (Federal and State)</span>
            </div>
              <div class="medium-3 column table-header-badge-tooltip">
              <span class="roi-table-heading">Actual Savings</span>
              <span class="bottomTooltiptext status-tooltip">Tax Savings after implementation (Federal and State)</span>
            </div>
            <div class="medium-3 column table-header-badge-tooltip" *ngIf="filterOptions.dollarChange">
              <span class="roi-table-heading">$ Change</span>
              <span class="bottomTooltiptext status-tooltip">Difference between Plan Savings and Actual Savings. For review with the client.</span>
            </div>
            <div class="medium-3 column table-header-badge-tooltip" *ngIf="filterOptions.percentageChange">
              <span class="roi-table-heading">% Change</span>
              <span class="bottomTooltiptext status-tooltip">% difference between Plan Savings and Actual Savings. For review with the client</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row" style="margin-bottom: 15px;margin-left: 35px;" *ngIf="!filterOptions.actual">
        <div class="medium-12 column table-header-badge-tooltip text-end">
            <div class="ms-auto d-inline position-relative">
            <span class="roi-table-heading">Planned Amount</span>
            <span class="bottomTooltiptext status-tooltip">Tax Savings amount in the proposal (Federal and State)</span>
            </div>
        </div>
  </div> -->
  <ng-template ngFor [ngForOf]="roiData.categories" let-category="$implicit" let-i="index">
    <div class="row" *ngIf="minimizedSections.indexOf('year' + (i+1)) == -1">
      <div class="medium-12 column">
        <span *ngIf="!isCustomer" class="section-icon float-left">
          <span (click)="minimizeOrMaximizeSection('year', 'add', i+1)">
            <i class="icon ion-android-remove"></i>
          </span>
        </span>
        <span style="font-size: 15px;">{{category.name}}:</span>
      </div>
    </div>
    <div class="row" *ngIf="minimizedSections.indexOf('year' + (i+1)) == -1">
      <div class="medium-12 column"  *ngIf= "filterOptions.actual">
        <div class="row roi-line" *ngFor="let saving of category.strategyInfo">
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="float-left" *ngIf="showStrategyLink && i==0"><a style="text-decoration: underline;" (click)="openStrategySinglePage(saving)">{{saving.name}}</a></div>
            <div class="float-left" *ngIf="!showStrategyLink || (showStrategyLink && i!=0)">{{saving.name}}</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            <div *ngIf="!filterOptions.actual" class="text-right">{{saving.amount | formatAmount:'$0,0'}}</div>
            <div class="row" *ngIf="filterOptions.actual">
              <div class="medium-3 column">
                <div>{{saving.amount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column">
                <div>{{saving.actualAmount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
                <div>{{saving.dollarChange | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
                <div>{{saving.percentageChange || 0}}%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row roi-line roi-total-line">
          <div class="column medium-12 mb-2"><hr class="mw-100" style="margin: 0"/></div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="total-color float-left">{{category.totalInfo.name}}:</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            
            <div *ngIf="!filterOptions.actual" class="text-right total-color roi-amount-total">{{category.totalInfo.amount | formatAmount:'$0,0'}}</div>
            <div class="row" *ngIf="filterOptions.actual">
              <div class="medium-3 column">
                <div class="total-color roi-amount-total">{{category.totalInfo.amount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column">
                <div class="total-color roi-amount-total">{{category.totalInfo.actualAmount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
                <div class="total-color roi-amount-total">{{category.totalInfo.dollarChange | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
                <div class="total-color roi-amount-total">{{category.totalInfo.percentageChange || 0}}%</div>
              </div>
            </div>
          </div>
          <div class="column medium-12 mt-2 mb-2"><hr style="margin: 0" class="mw-100"/></div>
        </div>
      </div>
         <!-- THIS STARTING OF  PART 1 OF ROI PAGE -->
       <!-- <div class="medium-12 column" *ngIf= "!filterOptions.actual && hasActualAmount">
        <div class="row roi-line" *ngFor="let saving of category.strategyInfo">
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="float-left" *ngIf="showStrategyLink && i==0"><a style="text-decoration: underline;" (click)="openStrategySinglePage(saving)">{{saving.name}}</a></div>
            <div class="float-left" *ngIf="!showStrategyLink || (showStrategyLink && i!=0)">{{saving.name}}</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            <div class="row justify-content-end">
              <div class="medium-3 column p-0 text-right">
                {{saving.actualAmount | formatAmount:'$0,0'}}
              </div>
            </div>
          </div>
        </div>
        <div class="row roi-line roi-total-line">
          <div class="column medium-12 mb-2"><hr style="margin: 0"/></div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="total-color float-left">{{category.totalInfo.name}}:</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            <div class="row justify-content-end">
              <div class="medium-3 column p-0">
                <div class="total-color roi-amount-total text-right">{{category.totalInfo.actualAmount | formatAmount:'$0,0'}}</div>
              </div>
            </div>
          </div>
          <div class="column medium-12 mt-2 mb-2"><hr style="margin: 0"/></div>
        </div>
      </div> -->
        <!-- THIS ENDING OF  PART 1 OF ROI PAGE -->
      <div class="medium-12 column"  *ngIf= "!filterOptions.actual">
        <div class="row roi-line" *ngFor="let saving of category.strategyInfo">
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="float-left" *ngIf="showStrategyLink && i==0"><a style="text-decoration: underline;" (click)="openStrategySinglePage(saving)">{{saving.name}}</a></div>
            <div class="float-left" *ngIf="!showStrategyLink || (showStrategyLink && i!=0)">{{saving.name}}</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            <div *ngIf="!filterOptions.actual" class="text-right">{{saving.amount | formatAmount:'$0,0'}}</div>
            <div class="row" *ngIf="filterOptions.actual">
              <div class="medium-3 column">
                <div>{{saving.amount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column">
                <div>{{saving.actualAmount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
                <div>{{saving.dollarChange | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
                <div>{{saving.percentageChange || 0}}%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row roi-line roi-total-line">
          <div class="column medium-12 mb-2"><hr style="margin: 0"/></div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="total-color float-left">{{category.totalInfo.name}}:</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            <div *ngIf="!filterOptions.actual" class="text-right total-color roi-amount-total">{{category.totalInfo.amount | formatAmount:'$0,0'}}</div>
            <div class="row" *ngIf="filterOptions.actual">
              <div class="medium-3 column">
                <div class="total-color roi-amount-total">{{category.totalInfo.amount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column">
                <div class="total-color roi-amount-total">{{category.totalInfo.actualAmount | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
                <div class="total-color roi-amount-total">{{category.totalInfo.dollarChange | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
                <div class="total-color roi-amount-total">{{category.totalInfo.percentageChange || 0}}%</div>
              </div>
            </div>
          </div>
          <div class="column medium-12 mt-2 mb-2"><hr class="mw-100" style="margin: 0"/></div>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="row" *ngIf="minimizedSections.indexOf('fees') == -1">
    <div class="medium-12 column">
      <span *ngIf="!isCustomer" class="section-icon float-left">
        <span (click)="minimizeOrMaximizeSection('fees')">
          <i class="icon ion-android-remove"></i>
        </span>
      </span>
      <span style="font-size: 15px;">Your investment in {{orgName}}:</span>
      <span *ngIf="!isCustomer && roiData.costlines && roiData.costlines.length > 0" class="pointer" style="text-decoration: underline;margin-left: 10px;" (click)="editRoiFees()"><i style="color: #44B6E8;" class="material-icons manage-strategy-icon">edit</i></span>
    </div>
  </div>
  <div class="row">
    <div class="medium-12 column">
      <ng-template [ngIf]="minimizedSections.indexOf('fees') == -1">
        <div *ngFor="let costLine of roiData.costlines">
        <div class="row roi-line" *ngIf="!(costLine.amount == 0)">
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="float-left">{{costLine.description}}</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            <ng-template [ngIf]="!filterOptions.actual">
              <div class="text-right"  *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</div>
              <div class="text-right" *ngIf="costLine.type == 'Priceless'">Priceless</div>
            </ng-template>
            <div class="row" *ngIf="filterOptions.actual">
              <div class="medium-3 column">
                <div *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</div>
                <div *ngIf="costLine.type == 'Priceless'">Priceless</div>
              </div>
              <div class="medium-3 column">
                <div *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</div>
                <div *ngIf="costLine.type == 'Priceless'">Priceless</div>
              </div>
              <div class="medium-3 column"></div>
              <div class="medium-3 column"></div>
            </div>          
          </div>
        </div>
        </div>
        <div class="row roi-line roi-total-line">
          <div class="column medium-12 mb-2"><hr class="mw-100" style="margin: 0"/></div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'">
            <div class="float-left total-color">Net Deductible Increase in Investment to us</div>
          </div>
          <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
            <div *ngIf="!filterOptions.actual" class="text-right total-color roi-amount-total">{{roiData.costLineTotal | formatAmount:'$0,0'}}</div>
            <div class="row" *ngIf="filterOptions.actual">
              <div class="medium-3 column">
                <div class="total-color roi-amount-total">{{roiData.costLineTotal | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column">
                <div class="total-color roi-amount-total">{{roiData.costLineTotal | formatAmount:'$0,0'}}</div>
              </div>
              <div class="medium-3 column"></div>
              <div class="medium-3 column"></div>
            </div>
          </div>
          <div class="column medium-12 mt-2"><hr class="mw-100" style="margin: 0"/></div>
        </div>
      </ng-template>
      <div class="row roi-line mt-2" *ngIf="minimizedSections.indexOf('afterTaxInvestment') == -1">
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'" style="padding: 0px;">
          <span *ngIf="!isCustomer" class="section-icon float-left">
            <span (click)="minimizeOrMaximizeSection('afterTaxInvestment')">
              <i class="icon ion-android-remove"></i>
            </span>
          </span>
          <div class="float-left">After tax investment</div>
        </div>
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4 text-right'">
          <div *ngIf="!filterOptions.actual" class="text-right badge-tooltip move-left d-inline">
            <span>{{roiData.afterTaxInvestment | formatAmount:'$0,0'}}</span>
            <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">Net deductible fee to the firm after associated with rates</span>
          </div>
          <div class="row" *ngIf="filterOptions.actual">
            <div class="medium-3 column">
              <div  class="badge-tooltip move-left d-inline">
                <span>{{roiData.afterTaxInvestment | formatAmount:'$0,0'}}</span>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">Net deductible fee to the firm after associated with rates</span>
              </div>
            </div>
            <div class="medium-3 column">
              <div  class="badge-tooltip move-left d-inline">
                <span>{{roiData.afterTaxActualInvestment | formatAmount:'$0,0'}}</span>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">Net deductible fee to the firm after associated with rates</span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
            </div>
          </div>
        </div>
      </div>
      <div class="row roi-line" *ngIf="minimizedSections.indexOf('afterTaxYearlyInvestment') == -1">
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'" style="padding: 0px;">
          <span *ngIf="!isCustomer" class="section-icon float-left">
            <span (click)="minimizeOrMaximizeSection('afterTaxYearlyInvestment')">
              <i class="icon ion-android-remove"></i>
            </span>
          </span>
          <div class="float-left">After Tax Yearly Investment to us after Year 1:</div>
        </div>
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4'">
          <div *ngIf="!filterOptions.actual" class="text-right badge-tooltip move-left">
            <span>{{roiData.afterTaxYearlyInvestment | formatAmount:'$0,0'}}</span>
            <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">Recurring  net deductible fee to the firm after associated with rates</span>
          </div>
          <div class="row" *ngIf="filterOptions.actual">
            <div class="medium-3 column">
              <div class="badge-tooltip move-left d-inline">
                <span>{{roiData.afterTaxYearlyInvestment | formatAmount:'$0,0'}}</span>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">Recurring  net deductible fee to the firm after associated with rates</span>
              </div>
            </div>
            <div class="medium-3 column">
              <div class="badge-tooltip move-left d-inline">
                <span>{{roiData.afterTaxYearlyActualInvestment | formatAmount:'$0,0'}}</span>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">Recurring  net deductible fee to the firm after associated with rates</span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="column medium-12"><hr class="mw-100" style="margin: 0"/></div>
      </div>
      <div class="row roi-line" *ngIf="minimizedSections.indexOf('year1ProjectedGain') == -1">
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'" style="padding: 0px;">
          <span *ngIf="!isCustomer" class="section-icon float-left">
            <span (click)="minimizeOrMaximizeSection('year1ProjectedGain')">
              <i class="icon ion-android-remove"></i>
            </span>
          </span>
          <div class="float-left total-color">Projected Gain on Your Investment by End of Year 1:</div>
        </div>
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4 text-right'">
          <div *ngIf="!filterOptions.actual" class="text-right total-color badge-tooltip move-left">
            <span>{{roiData.year1ProjectedGain | formatAmount:'$0,0'}}</span>
            <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
              Projected Gain on investment = "Estimated Year 1 Tax Savings" less "After Tax Investment"
            </span>
          </div>
          <div class="row" *ngIf="filterOptions.actual">
            <div class="medium-3 column">
              <div class="total-color badge-tooltip move-left d-inline">
                <span>{{roiData.year1ProjectedGain | formatAmount:'$0,0'}}</span>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  Projected Gain on investment = "Estimated Year 1 Tax Savings" less "After Tax Investment"
                </span>
                </div>
              </div>
            <div class="medium-3 column">
              <div class="total-color badge-tooltip move-left d-inline">
                <span>{{roiData.year1ActualProjectedGain | formatAmount:'$0,0'}}</span>
                 <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  Projected Gain on investment = "Estimated Year 1 Tax Savings" less "After Tax Investment"
                </span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
              <div class="total-color">
                <span>{{roiData.year1ProjectedGainDifference | formatAmount:'$0,0'}}</span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
              <div class="total-color">
                <span>{{roiData.year1ProjectedGainPercentDiff || 0}}%</span>
              </div>
            </div>
          </div>
             <!-- THIS STARTING OF  PART 2 OF ROI PAGE -->
            <!-- <div class="row justify-content-end" *ngIf="!filterOptions.actual && hasActualAmount" style="padding-left: 20px;">
            <div class="medium-3 column p-0">
               <div class="tooltip-text text-blue badge-tooltip move-left d-inline">
              <div class="total-color text-right">
               {{roiData.year1ActualProjectedGain | formatAmount:'$0,0'}}
              </div>
               <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
              Projected Gain on investment = "Estimated Year 1 Tax Savings" less "After Tax Investment"
            </span>
            </div>
            </div>
            <div class="medium-3 column p-0" *ngIf="filterOptions.dollarChange">
              <div class="total-color text-right">
               {{roiData.year1ProjectedGainDifference | formatAmount:'$0,0'}}
              </div>
            </div>
            <div class="medium-3 column p-0" *ngIf="filterOptions.percentageChange">
              <div class="total-color text-right">
               {{roiData.year1ProjectedGainPercentDiff || 0}}%
              </div>
            </div>
          </div> -->
            <!-- THIS ENDING OF  PART 2 OF ROI PAGE -->
        </div>
      </div>
      <div class="row roi-line" *ngIf="minimizedSections.indexOf('year1ROI') == -1">
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'" style="padding: 0px;">
          <span *ngIf="!isCustomer" class="section-icon float-left">
            <span (click)="minimizeOrMaximizeSection('year1ROI')">
              <i class="icon ion-android-remove"></i>
            </span>
          </span>
          <div class="float-left total-color">Return on investment by End of Year 1:</div>
        </div>
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4 text-right'">
          <div *ngIf="!filterOptions.actual" class="text-right total-color roi-percentage badge-tooltip move-left d-inline">
            <span *ngIf="roiData.year1ROI !== 'Unlimited, No Fees'">{{roiData.year1ROI}}</span>
            <a *ngIf="roiData.year1ROI === 'Unlimited, No Fees'" (click)="onUnlimitedNoFeesClick()" style="color: #1570EF; text-decoration: underline; cursor: pointer;">{{roiData.year1ROI}}</a>
            <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
              "Projected Gain on investment" divided by "After Tax Investment"
            </span>
          </div>
          <div class="row" *ngIf="filterOptions.actual">
            <div class="medium-3 column">
              <div class="total-color roi-percentage badge-tooltip move-left d-inline">
                <span *ngIf="roiData.year1ROI !== 'Unlimited, No Fees'">{{roiData.year1ROI}}</span>
                <a *ngIf="roiData.year1ROI === 'Unlimited, No Fees'" (click)="onUnlimitedNoFeesClick()" style="color: #1570EF; text-decoration: underline; cursor: pointer;">{{roiData.year1ROI}}</a>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  "Projected Gain on investment" divided by "After Tax Investment"
                </span>
              </div>
            </div>
            <div class="medium-3 column">
              <div class="total-color roi-percentage badge-tooltip move-left d-inline">
                <span *ngIf="roiData.year1ActualROI !== 'Unlimited, No Fees'">{{roiData.year1ActualROI}}</span>
                <a *ngIf="roiData.year1ActualROI === 'Unlimited, No Fees'" (click)="onUnlimitedNoFeesClick()" style="color: #1570EF; text-decoration: underline; cursor: pointer;">{{roiData.year1ActualROI}}</a>
                 <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  "Projected Gain on investment" divided by "After Tax Investment"
                </span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
              <div class="total-color"></div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
              <div class="total-color roi-percentage">
                <span>{{roiData.year1ROIPercnetDifference || ''}}</span>
              </div>
            </div>
          </div>
            <!-- THIS STARTING OF  PART 3 OF ROI PAGE -->
          <!-- <div class="row justify-content-end" *ngIf="!filterOptions.actual && hasActualAmount" style="padding-left: 20px;">
            <div class="medium-3 column p-0">
              <div class="tooltip-text text-blue badge-tooltip move-left d-inline">
              <div class="total-color text-right roi-percentage">
                {{roiData.year1ActualROI}}
              </div>
               <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  "Projected Gain on investment" divided by "After Tax Investment"
                </span>
                </div>
            </div>
            <div class="medium-3 column p-0" *ngIf="filterOptions.dollarChange">
              <div class="total-color text-right"></div>
            </div>
            <div class="medium-3 column p-0" *ngIf="filterOptions.percentageChange">
              <div class="total-color text-right roi-percentage">
                {{roiData.year1ROIPercnetDifference || ''}}
              </div>
            </div>
          </div> -->
              <!-- THIS ENDING OF  PART 3 OF ROI PAGE -->
        </div>
      </div>
      <div class="row roi-line" *ngIf="minimizedSections.indexOf('projectedSavingsNext10') == -1">
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'" style="padding: 0px;">
          <span *ngIf="!isCustomer" class="section-icon float-left">
            <span (click)="minimizeOrMaximizeSection('projectedSavingsNext10')">
              <i class="icon ion-android-remove"></i>
            </span>
          </span>
          <div class="float-left total-color">Projected Net Tax Savings for Year 2 to {{roiData.customizedYear || 10}}:</div>
        </div>
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4 text-right'">
          <div *ngIf="!filterOptions.actual" class="text-right total-color badge-tooltip move-left d-inline">
            <span>{{roiData.projectedSavingsNext10 | formatAmount:'$0,0'}}</span>
            <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
              (Year 2 & forward savings less yearly investment after year 1) X {{defaultROICustomization - 1}}
            </span>
          </div>
          <div class="row" *ngIf="filterOptions.actual">
            <div class="medium-3 column">
              <div class="total-color badge-tooltip move-left d-inline">
                <span>{{roiData.projectedSavingsNext10 | formatAmount:'$0,0'}}</span>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  (Year 2 & forward savings less yearly investment after year 1) X {{defaultROICustomization - 1}}
                </span>
              </div>
            </div>
            <div class="medium-3 column">
              <div class="total-color badge-tooltip move-left d-inline">
                <span>{{roiData.actualProjectedSavingsNext10 | formatAmount:'$0,0'}}</span>
                <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  (Year 2 & forward savings less yearly investment after year 1) X {{defaultROICustomization - 1}}
                </span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
              <div class="total-color">
                <span>{{roiData.projectedSavingsNext10Difference | formatAmount:'$0,0'}}</span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
              <div class="total-color">
                <span>{{roiData.projectedSavingsNext10PercentDiff || 0}}%</span>
              </div>
            </div>
          </div>
            <!-- THIS STARTING OF  PART 4 OF ROI PAGE -->
          <!-- <div class="row justify-content-end" *ngIf="!filterOptions.actual && hasActualAmount" style="padding-left: 20px;">
            <div class="medium-3 column p-0">
                <div class="tooltip-text text-blue badge-tooltip move-left d-inline">
              <div class="total-color text-right">
                {{roiData.actualProjectedSavingsNext10 | formatAmount:'$0,0'}}
              </div>
              <span class="tooltip-text text-blue" style="min-width: 250px; font-size: 14px;">
                  (Year 2 & forward savings less yearly investment after year 1) X {{defaultROICustomization - 1}}
                </span>
              </div>
            </div>
            <div class="medium-3 column p-0" *ngIf="filterOptions.dollarChange">
              <div class="total-color text-right">
                {{roiData.projectedSavingsNext10Difference | formatAmount:'$0,0'}}
              </div>
            </div>
            <div class="medium-3 column p-0" *ngIf="filterOptions.percentageChange">
              <div class="total-color text-right">
                {{roiData.projectedSavingsNext10PercentDiff || 0}}%
              </div>
            </div>
          </div> -->
             <!-- THIS ENDING OF  PART 4 OF ROI PAGE -->
        </div>
      </div>
      <div class="row roi-line total-savings" *ngIf="minimizedSections.indexOf('totalTaxSavings') == -1">
        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-8'" style="padding: 0px;">
            <span *ngIf="!isCustomer" class="section-icon float-left">
              <span (click)="minimizeOrMaximizeSection('totalTaxSavings')">
                <i class="icon ion-android-remove"></i>
              </span>
            </span>
          <div class="float-left total-color" *ngIf="!roiCustomize">Total Tax Savings Over the Next {{roiData.customizedYear || 10}} Years
            <span *ngIf="!isCustomer && !readOnly" (click)="editROIForCustomize()"><i style="color: #44B6E8;" class="material-icons manage-strategy-icon">edit</i></span>
          </div>
          <div class="float-left total-color roi-customize" style="display: flex" *ngIf="roiCustomize">Total Tax Savings Over the Next
            <span style="width: 70px;margin: 0 10px;position: relative;bottom: 7px;">
              <app-tpiq-select-dropdown [setData]="roiCustomizations" [includeNone]="false" (onValueSelect)="setRoiCustomization($event)"
                                     [setDefaultValue]="defaultROICustomization" [setSearchKey]="'name'" [setPlaceHolder]="''" [setValueKey]="'name'"></app-tpiq-select-dropdown>
            </span>Years
          </div>
        </div>

        <div class="column" [ngClass]="filterOptions.actual ? 'medium-6': 'medium-4 text-right'">
          <div *ngIf="!filterOptions.actual" class="text-right total-color badge-tooltip customtoptool">
            <span>{{roiData.totalTaxSavings | formatAmount:'$0,0'}}</span>
            <span class="topTooltiptext move-right" style="min-width: 250px; font-size: 14px;">
              Year 1 Projected Gain on Investment + Year 2 & Forward Savings
            </span>
          </div>
          <div class="row" *ngIf="filterOptions.actual">
            <div class="medium-3 column">
              <div class="total-color badge-tooltip customtoptool d-inline">
                <span>{{roiData.totalTaxSavings | formatAmount:'$0,0'}}</span>
                <span class="topTooltiptext move-right" style="min-width: 250px; font-size: 14px;">
                  Year 1 Projected Gain on Investment + Year 2 & Forward Savings
                </span>
              </div>
            </div>
            <div class="medium-3 column">
              <div class="total-color badge-tooltip customtoptool d-inline">
                <span>{{roiData.actualTotalTaxSavings | formatAmount:'$0,0'}}</span>
                 <span class="topTooltiptext move-right" style="min-width: 250px; font-size: 14px;">
                  Year 1 Projected Gain on Investment + Year 2 & Forward Savings
                </span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.dollarChange">
              <div class="total-color">
                <span>{{roiData.totalTaxSavingsDifference | formatAmount:'$0,0'}}</span>
              </div>
            </div>
            <div class="medium-3 column" *ngIf="filterOptions.percentageChange">
              <div class="total-color">
                <span>{{roiData.totalTaxSavingsPercentDiff || 0}}%</span>
              </div>
            </div>
          </div>
            <!-- THIS STARTING OF  PART 5 OF ROI PAGE -->
          <!-- <div class="row" *ngIf="!filterOptions.actual && hasActualAmount" style="padding-left: 20px;">
            <div class="medium-12 column p-0">
              <div class="total-color badge-tooltip customtoptool d-inline">
              <div class="text-right total-color">
                {{roiData.actualTotalTaxSavings | formatAmount:'$0,0'}}
              </div>
              <span class="topTooltiptext move-right" style="min-width: 250px; font-size: 14px;">
                  Year 1 Projected Gain on Investment + Year 2 & Forward Savings
                </span>
                </div>
            </div>
            <div class="medium-12 column p-0" *ngIf="filterOptions.dollarChange">
              <div class="text-right total-color">
                {{roiData.totalTaxSavingsDifference | formatAmount:'$0,0'}}
              </div>
            </div>
            <div class="medium-12 column p-0" *ngIf="filterOptions.percentageChange">
              <div class="text-right total-color">
                {{roiData.totalTaxSavingsPercentDiff || 0}}%
              </div>
            </div>
          </div> -->
            <!-- THIS ENDING OF  PART 5 OF ROI PAGE -->
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-top: 30px;" *ngIf="roiData.disclaimer">
    <div class="medium-12 columns">
      <div style="font-size: 15px;">Disclaimer:</div>
      <p style="font-size: 14px;" [innerHTML]="roiData.disclaimer"></p>
    </div>
  </div>
</div>

<div id="numeric" style="display: none;">
  <table style="font-size: 15px; margin-top: 30px; width: 100%;">
    <thead style="background: none;">
    <tr style="height: 50px;">
      <th colspan="8" style="text-align: center;" [ngStyle]="{'background-color': backgroundColor}">
        ````
      </th>
    </tr>
    <tr style="height: 10px;">
      <td colspan="8"></td>
    </tr>
    <tr style="height: 36px;">
      <th colspan="8" style="text-align: center; font-size: 20px;">
        Tax Savings Analysis for {{taxYear || ''}}
      </th>
    </tr>
    <tr style="height: 36px;">
      <th colspan="8" style="text-align: center; font-size: 16px;">
        {{roiData.userName}}
      </th>
    </tr>
    <tr style="height: 36px;">
      <th colspan="8" style="text-align: center; font-size: 16px;">
        {{roiData.strategyName}}
      </th>
    </tr>
    <tr style="height: 10px;">
      <td colspan="8"></td>
    </tr>
    </thead>
    <tbody>
    <tr style="height: 10px;" *ngIf="filterOptions.actual">
      <td colspan="4"></td>
      <td style="text-align: right;">Plan</td>
      <td style="text-align: right;">Actual</td>
      <td style="text-align: right;">$ Change</td>
      <td style="text-align: right;">% Change</td>
    </tr>
    <ng-template ngFor [ngForOf]="roiData.categories" let-category="$implicit" let-i="index">
      <ng-template [ngIf]="minimizedSections.indexOf('year' + (i+1)) == -1">
        <tr style="font-weight: bold; height: 36px;">
          <td colspan="8">{{category.name}}</td>
        </tr>
        <tr *ngFor="let saving of category.strategyInfo" style="height: 36px;">
          <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">{{saving.name}}</td>
          <td style="text-align: right;" *ngIf="!filterOptions.actual">{{saving.amount | formatAmount:'$0,0'}}</td>
          <ng-template [ngIf]="filterOptions.actual">
            <td style="text-align: right;">{{saving.amount | formatAmount:'$0,0'}}</td>
            <td style="text-align: right;">{{saving.actualAmount | formatAmount:'$0,0'}}</td>
            <td style="text-align: right;" *ngIf="filterOptions.dollarChange">{{saving.dollarChange | formatAmount:'$0,0'}}</td>
            <td style="text-align: right;" *ngIf="filterOptions.percentageChange">{{saving.percentageChange || 0}}%</td>
          </ng-template>
          <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
            <td style="text-align: right;">{{saving.actualAmount | formatAmount:'$0,0'}}</td>
          </ng-template> -->
        </tr>
        <tr>
          <td colspan="8" style="border-top: 1px solid #878787;"></td>
        </tr>
        <tr style="height: 36px;color: #1570EF; border-top: 1px solid #878787;border-bottom: 1px solid #878787;">
          <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">{{category.totalInfo.name}}</td>
          <td style="text-align: right;" *ngIf="!filterOptions.actual">{{category.totalInfo.amount | formatAmount:'$0,0'}}</td>
          <ng-template [ngIf]="filterOptions.actual">
            <td style="text-align: right;">{{category.totalInfo.amount | formatAmount:'$0,0'}}</td>
            <td style="text-align: right;">{{category.totalInfo.actualAmount | formatAmount:'$0,0'}}</td>
            <td style="text-align: right;" *ngIf="filterOptions.dollarChange">{{category.totalInfo.dollarChange | formatAmount:'$0,0'}}</td>
            <td style="text-align: right;" *ngIf="filterOptions.percentageChange">{{category.totalInfo.percentageChange || 0}}%</td>
          </ng-template>
           <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
            <td style="text-align: right;">{{category.totalInfo.actualAmount | formatAmount:'$0,0'}}</td>
          </ng-template> -->
        </tr>
        <tr>
          <td colspan="8" style="border-top: 1px solid #878787;"></td>
        </tr>
        <tr style="height: 10px;">
          <td colspan="8"></td>
        </tr>
      </ng-template>
    </ng-template>
    <ng-template [ngIf]="minimizedSections.indexOf('fees') == -1">
      <tr style="height: 36px;">
        <td colspan="8" style="color: #1570EF;">Your investment in {{orgName}}:</td>
      </tr>
      <tr *ngFor="let costLine of roiData.costlines" style="height: 36px;">
        <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">{{costLine.description}}</td>
        <ng-template [ngIf]="!filterOptions.actual">
          <td style="text-align: right;" *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</td>
          <td style="text-align: right;" *ngIf="costLine.type == 'Priceless'">Priceless</td>
        </ng-template>
        <ng-template [ngIf]="filterOptions.actual">
          <td style="text-align: right;" *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</td>
          <td style="text-align: right;" *ngIf="costLine.type == 'Priceless'">Priceless</td>
          <td style="text-align: right;" *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</td>
          <td style="text-align: right;" *ngIf="costLine.type == 'Priceless'">Priceless</td>
        </ng-template>
        <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
          <td style="text-align: right;" *ngIf="costLine.type != 'Priceless'">{{costLine.amount | formatAmount:'$0,0'}}</td>
          <td style="text-align: right;" *ngIf="costLine.type == 'Priceless'">Priceless</td>
        </ng-template> -->
      </tr>
      <tr>
        <td colspan="8" style="border-top: 1px solid #878787;"></td>
      </tr>

      <tr style="height: 36px;color: #1570EF; border-top: 1px solid #878787;border-bottom: 1px solid #878787;">
        <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">Net Deductible Increase in Investment to us:</td>
        <td style="text-align: right;" *ngIf="!filterOptions.actual">{{roiData.costLineTotal | formatAmount:'$0,0'}}</td>
        <ng-template [ngIf]="filterOptions.actual">
          <td style="text-align: right;">{{roiData.costLineTotal | formatAmount:'$0,0'}}</td>
          <td style="text-align: right;">{{roiData.costLineTotal | formatAmount:'$0,0'}}</td>
        </ng-template>
        <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
          <td style="text-align: right;">{{roiData.costLineTotal | formatAmount:'$0,0'}}</td>
        </ng-template> -->
      </tr>
      <tr>
        <td colspan="8" style="border-top: 1px solid #878787;"></td>
      </tr>
      <tr style="height: 10px;">
        <td colspan="8"></td>
      </tr>
    </ng-template>
    <tr style="height: 36px;"  *ngIf="minimizedSections.indexOf('afterTaxInvestment') == -1">
      <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">After tax investment:</td>
      <td style="text-align: right;" *ngIf="!filterOptions.actual">{{roiData.afterTaxInvestment | formatAmount:'$0,0'}}</td>
      <ng-template [ngIf]="filterOptions.actual">
        <td style="text-align: right;">{{roiData.afterTaxInvestment | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;">{{roiData.afterTaxActualInvestment | formatAmount:'$0,0'}}</td>
      </ng-template>
       <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
        <td style="text-align: right;">{{roiData.afterTaxActualInvestment | formatAmount:'$0,0'}}</td>
      </ng-template> -->
    </tr>
    <tr style="height: 36px;" *ngIf="minimizedSections.indexOf('afterTaxYearlyInvestment') == -1">
      <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">After Tax Yearly Investment to us after Year 1:</td>
      <td style="text-align: right;" *ngIf="!filterOptions.actual">{{roiData.afterTaxYearlyInvestment | formatAmount:'$0,0'}}</td>
      <ng-template [ngIf]="filterOptions.actual">
        <td style="text-align: right;">{{roiData.afterTaxYearlyInvestment | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;">{{roiData.afterTaxYearlyActualInvestment | formatAmount:'$0,0'}}</td>
      </ng-template>
      <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
        <td style="text-align: right;">{{roiData.afterTaxYearlyActualInvestment | formatAmount:'$0,0'}}</td>
      </ng-template> -->
    </tr>
    <tr>
      <td colspan="8" style="border-top: 1px solid #878787;"></td>
    </tr>
    <tr style="height: 10px;">
      <td colspan="8"></td>
    </tr>
    <tr style="height: 36px;color: #1570EF;" *ngIf="minimizedSections.indexOf('year1ProjectedGain') == -1">
      <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">Projected Gain on Your Investment by End of Year 1:</td>
      <td style="text-align: right;" *ngIf="!filterOptions.actual">{{roiData.year1ProjectedGain | formatAmount:'$0,0'}}</td>
      <ng-template [ngIf]="filterOptions.actual">
        <td style="text-align: right;">{{roiData.year1ProjectedGain | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;">{{roiData.year1ActualProjectedGain | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;" *ngIf="filterOptions.dollarChange">{{roiData.year1ProjectedGainDifference | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;" *ngIf="filterOptions.percentageChange">{{roiData.year1ProjectedGainPercentDiff || 0}}%</td>
      </ng-template>
       <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
        <td style="text-align: right;">{{roiData.year1ActualProjectedGain | formatAmount:'$0,0'}}</td>
      </ng-template> -->
    </tr>
    <tr style="height: 36px;color: #1570EF;" *ngIf="minimizedSections.indexOf('year1ROI') == -1">
      <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">Return on investment:</td>
      <td style="text-align: right;" *ngIf="!filterOptions.actual">{{roiData.year1ROI}}</td>
      <ng-template [ngIf]="filterOptions.actual">
        <td style="text-align: right;">{{roiData.year1ROI}}</td>
        <td style="text-align: right;">{{roiData.year1ActualROI}}</td>
        <td style="text-align: right;" *ngIf="filterOptions.dollarChange"></td>
        <td style="text-align: right;" *ngIf="filterOptions.percentageChange">{{roiData.year1ROIPercnetDifference || ''}}</td>
      </ng-template>
      <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
        <td style="text-align: right;">{{roiData.year1ActualROI}}</td>
      </ng-template> -->
    </tr>
    <tr style="height: 36px;color: #1570EF;" *ngIf="minimizedSections.indexOf('projectedSavingsNext10') == -1">
      <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">Projected Net Tax Savings for Year 2 to {{roiData.customizedYear || 10}}:</td>
      <td style="text-align: right;" *ngIf="!filterOptions.actual">{{roiData.projectedSavingsNext10 | formatAmount:'$0,0'}}</td>
      <ng-template [ngIf]="filterOptions.actual">
        <td style="text-align: right;">{{roiData.projectedSavingsNext10 | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;">{{roiData.actualProjectedSavingsNext10 | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;" *ngIf="filterOptions.dollarChange">{{roiData.projectedSavingsNext10Difference | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;" *ngIf="filterOptions.percentageChange">{{roiData.projectedSavingsNext10PercentDiff || 0}}%</td>
      </ng-template>
       <!-- <ng-template [ngIf]="!filterOptions.actual && hasActualAmount">
        <td style="text-align: right;">{{roiData.actualProjectedSavingsNext10 | formatAmount:'$0,0'}}</td>
      </ng-template> -->
    </tr>
    <tr>
      <td colspan="8" style="border-top: 1px solid #878787;"></td>
    </tr>
    <tr style="height: 36px;color: #1570EF;" *ngIf="minimizedSections.indexOf('totalTaxSavings') == -1">
      <td [attr.colspan]="!filterOptions.actual ? '7' : '4'">Total Tax Savings Over the Next 10 Years</td>
      <td style="text-align: right;" *ngIf="!filterOptions.actual">{{roiData.totalTaxSavings | formatAmount:'$0,0'}}</td>
      <ng-template [ngIf]="filterOptions.actual">
        <td style="text-align: right;">{{roiData.totalTaxSavings | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;">{{roiData.actualTotalTaxSavings | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;" *ngIf="filterOptions.dollarChange">{{roiData.totalTaxSavingsDifference | formatAmount:'$0,0'}}</td>
        <td style="text-align: right;" *ngIf="filterOptions.percentageChange">{{roiData.totalTaxSavingsPercentDiff || 0}}%</td>
      </ng-template>
    </tr>
    <tr>
      <td colspan="8" style="border-top: 1px solid #878787;"></td>
    </tr>
    <tr style="height: 30px;" *ngIf="roiData.disclaimer">
      <td colspan="8"></td>
    </tr>
    <tr *ngIf="roiData.disclaimer">
      <td colspan="8" style="font-size: 14px;" [innerHTML]="roiData.disclaimer"></td>
    </tr>
    </tbody>
  </table>
</div>

<div *ngIf="reveal['roiFees']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['roiFees']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 85%;" [ngClass]="{'tpiq-reveal': reveal['roiFees']}">
    <div class="header" style="height: 50px; background-color: #16477a; padding: 15px; color: #fff;">
      <span class="float-left">Edit ROI Fees</span>
      <span class="float-right pointer" (click)="hideReveal('roiFees')">X</span>
    </div>
    <div class="body new-input-fields" style="padding: 15px;">
      <div class="row" *ngFor="let costLine of roiEditFees">
        <div class="medium-6 columns">
          <input type="text" placeholder="Description" [(ngModel)]="costLine.description" />
        </div>
        <div class="medium-2 columns">
          <input class="float-left" placeholder="Amount" type="text" [(ngModel)]="costLine.amount" model-numeral [locale]="'USD'" [format]="'$0,0.00'"/>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <button style="margin-top: 10px;" class="button small float-right" [disabled]="readOnly" (click)="updateRoiFees()">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
